import type { Checkin } from "~/types";
import { Card } from "./Card";

interface CardsProps {
  checkins: Checkin[];
  externalVenueLink?: boolean;
}

export const Cards = ({ checkins, externalVenueLink }: CardsProps) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        maxWidth: 'var(--card-max-width)',
        width: 'auto',
      }}
    >
      {checkins.map((checkin) => (
        <Card
          checkin={checkin}
          key={`checkin-${checkin.id}`}
          externalVenueLink={!!externalVenueLink}
        />
      ))}
    </div>
  );
}

export default Cards;
